import React from "react";

const GOLD = "#ebb51b";
const GRAY = "#9a9ca1";

export const PickupIcon = ({
  size = 32,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Camion secondario / profondità */}
      <path
        d="
          M4.2 6.2
          H14.8
          C15.5 6.2 16 6.7 16 7.4
          V9.1
          H18.1
          C18.7 9.1 19.2 9.4 19.5 9.9
          L21 12.5
          V16.8
          H18.8
          C18.5 15.4 17.4 14.4 16 14.4
          C14.6 14.4 13.5 15.4 13.2 16.8
          H8.5
          C8.2 15.4 7.1 14.4 5.7 14.4
          C4.3 14.4 3.2 15.4 2.9 16.8
          H2.5
          V7.9
          C2.5 6.9 3.2 6.2 4.2 6.2
          Z
        "
        fill={GRAY}
        opacity="0.55"
      />

      {/* Cassone principale */}
      <path
        d="
          M3.8 5.2
          H14.2
          C15 5.2 15.5 5.8 15.5 6.5
          V8.5
          H17.7
          C18.4 8.5 19 8.9 19.3 9.5
          L20.8 12.2
          V16.2
          H18.5
          C18.2 14.8 17.1 13.8 15.7 13.8
          C14.3 13.8 13.2 14.8 12.9 16.2
          H8.2
          C7.9 14.8 6.8 13.8 5.4 13.8
          C4 13.8 2.9 14.8 2.6 16.2
          H2.5
          V6.5
          C2.5 5.8 3 5.2 3.8 5.2
          Z
        "
        fill={GOLD}
      />

      {/* Cabina / parabrezza */}
      <path
        d="
          M15.5 8.5
          H17.4
          C17.8 8.5 18.1 8.7 18.3 9.1
          L19.8 11.8
          H15.5
          Z
        "
        fill="#202227"
        opacity="0.72"
      />

      {/* Separazione cassone / cabina */}
      <path
        d="M15.5 6.6V12"
        stroke="#202227"
        strokeWidth="1.1"
        opacity="0.65"
      />

      {/* Maniglia / dettaglio */}
      <path
        d="M5.2 7.5H11.8"
        stroke="#202227"
        strokeWidth="1.1"
        strokeLinecap="round"
        opacity="0.65"
      />

      {/* Ruota posteriore */}
      <circle
        cx="5.4"
        cy="16.5"
        r="2"
        fill="#202227"
      />
      <circle
        cx="5.4"
        cy="16.5"
        r="0.8"
        fill={GRAY}
      />

      {/* Ruota anteriore */}
      <circle
        cx="15.8"
        cy="16.5"
        r="2"
        fill="#202227"
      />
      <circle
        cx="15.8"
        cy="16.5"
        r="0.8"
        fill={GRAY}
      />

      {/* Piccolo dettaglio sul cassone */}
      <path
        d="M6.8 10H12"
        stroke="#202227"
        strokeWidth="1.15"
        strokeLinecap="round"
        opacity="0.65"
      />
    </svg>
  );
};

export default PickupIcon;